<template>
  <v-data-table :headers="headers" :items="rows" :hide-actions="!paginate">
    <template v-slot:items="props">
      <tr v-if="props.item._id">
        <td>
          <v-btn icon :to="`/project/${props.item._id}`" target="_blank">
            <v-icon>folder</v-icon>
          </v-btn>
        </td>
        <td>{{ props.item.firstName }}</td>
        <td>{{ props.item.lastName }}</td>
        <td>{{ formatStep(props.item.step) }}</td>
        <td>{{ props.item.amount }} €</td>
        <td>
          {{ formatRoles(props.item.roles) }}
        </td>
      </tr>
      <tr v-else>
        <td colspan="3">Ajustement</td>
        <td>{{ props.item.amount }} €</td>
        <td></td>
      </tr>
    </template>
    <template v-slot:footer v-if="showTotal">
      <td colspan="4">Total</td>
      <td>{{ total }} €</td>
      <td></td>
    </template>
  </v-data-table>
</template>

<script>
import * as _ from "lodash";
import { COLUMNS_NAMES } from "@/data/DefaultSettings";
import { roleToHumanReadable } from "../../data/leaseData";

export default {
  name: "BillDataTable",
  data: function() {
    return {
      headers: [
        { text: "Lien", sortable: false },
        { text: "Prénom", value: "firstName" },
        { text: "Nom", value: "lastName" },
        { text: "Étape", value: "step" },
        { text: "Montant", value: "amount" },
        { text: "Rôles", value: "roles" }
      ]
    };
  },
  props: {
    billingEntry: Object,
    paginate: { type: Boolean, default: true },
    showTotal: { type: Boolean, default: true }
  },
  computed: {
    total() {
      return (
        this.billingEntry.projects.reduce(
          (sum, project) => sum + project.amount,
          0
        ) + (this.billingEntry.custom || 0)
      );
    },
    rows() {
      if (this.billingEntry.custom) {
        return [
          ...this.billingEntry.projects,
          { amount: this.billingEntry.custom }
        ];
      }

      return this.billingEntry.projects;
    }
  },
  methods: {
    formatRoles(roles) {
      const bonusRoles = { allRolesBonus: "rôles", visits: "visites" };
      const [bonuses, standardRoles] = _.partition(
        roles,
        role => role in bonusRoles
      );
      return `${standardRoles
        .map(role => roleToHumanReadable(role))
        .join(", ")}${
        bonuses.length
          ? ` (+ bonus ${bonuses.map(bonus => bonusRoles[bonus]).join(", ")})`
          : ""
      }`;
    },
    formatStep(step) {
      return COLUMNS_NAMES[step];
    }
  }
};
</script>
